export const MODULE_PARAM_NAME = 'module';
export const MODULE_TEMPLATE = `/:${MODULE_PARAM_NAME}`;
